import { Connect } from 'components/connect';
const ConnectContainer = Connect;
export { ConnectContainer };
